<template>
    <div class="message-chat_messages d-flex flex-column-reverse px-3 pt-3">
        <div class="message-chat_message d-flex mb-3"
            @click="readMessage(message)"
            :class="{ 'justify-content-end': parseInt(message.ChatIncoming), 'cursor-pointer': !parseInt(message.ChatIncoming) && !parseInt(message.ChatIsRead) }">
            <div class="px-3 py-2 message-chat_message-inner"
                :class="{ 'bg-light-blue': !parseInt(message.ChatIncoming) }">
                <div class="fs-6 message-chat_claim" v-if="message.ChatClaim">{{ message.ChatClaim }}</div>
                <div class="d-inline-flex align-items-center">
                    <font-awesome-icon :icon="['fas', messageIcons[message.ChatTypeLName.toLowerCase()].icon]"
                        size="xs" class="me-2"
                        :style="{ color: messageIcons[message.ChatTypeLName.toLowerCase()].color }" />
                    <span class="me-2">{{ message.ChatText }}</span>
                    <small>{{ formatDate(message.ChatEdate) }}</small>
                    <span
                        :class="{ 'is-read': parseInt(message.ChatIsRead) }"
                        class="ms-2 message-chat_message-icon">
                        <font-awesome-icon :icon="['fas', 'check']" size="xs" />
                    </span>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MessageFilterItem',
    props: {
        message: {
            type: Object,
            required: true
        },
        claimId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            messageIcons: {
                message: { icon: 'message', color: 'var(--bs-purple)' },
                information: { icon: 'circle-info', color: 'var(--bs-primary)' },
                congratulation: { icon: 'gift', color: 'var(--bs-green)' },
                urgent: { icon: 'bolt-lightning', color: 'var(--bs-yellow)' },
                important: { icon: 'triangle-exclamation', color: 'var(--bs-red)' }
            }
        }
    },
    methods: {
        formatDate(date) {
            return new Date(date).toLocaleString();
        },
        readMessage(message) {
            if(parseInt(message.ChatIncoming) || parseInt(message.ChatIsRead))
                return false;
            this.$store.dispatch('messages/setRead', {chat_id: message.ChatInc}).then((response) => {
                this.$store.commit("messages/setRead", message.ChatInc);
            });
        }
    }
}
</script>

<style scoped>
.message-filter-item {
    background: var(--bs-white);
    border-radius: 6px;
    transition-duration: .25s;
}

.message-filter-item:hover {
    box-shadow: 0 4px 6px rgba(0, 0, 0, .1);
}

.message-item_info {
    width: 180px;
    border-right: 1px solid #eee;
}

.message-item_number {
    font-weight: 500;
    border: 2px solid;
    border-radius: 6px;
    border-color: var(--bs-primary);
    color: var(--bs-primary);
}

.message-item_date {
    font-weight: 500;
    color: black;
}

.message-chat {
    width: calc(100% - 180px);
    position: relative;
}

.message-chat_message-inner {
    position: relative;
    border-radius: 10px;
    background: var(--bs-gray-100);
}

.dark-mode .message-chat_message-inner {
    background: var(--bs-gray-600);
}

.message-chat_message-inner small {
    font-size: 80%;
    font-weight: 100;
}

.bg-light-blue small {
    color: var(--bs-primary);
    opacity: 1;
}

.message-chat_message-inner::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: -5px;
    border: 10px solid transparent;
    border-bottom: 10px solid #f8f9fa;
}
.dark-mode .message-chat_message-inner::after {
    border-bottom: 10px solid var(--bs-gray-600);
}

.bg-light-blue.message-chat_message-inner::after {
    right: auto;
    left: -5px;
    border-bottom: 10px solid #d0e8ff;
}
.bg-light-blue{
    background: #d0e8ff;
}

.dark-mode .bg-light-blue{
    background: var(--bs-gray-700);
}

.dark-mode .bg-light-blue.message-chat_message-inner::after {
    border-bottom: 10px solid var(--bs-gray-700);
}

.message-chat_message-icon svg {
    color: rgb(97, 97, 97, .5);
}

.message-chat_message-icon.is-read svg {
    color: var(--bs-primary);
}

.message-chat_send-message {
    border-top: 1px solid #eee;
}

.message-filter-item {
    border: 1px solid #eee;
}

.message-chat_claim{
    color: var(--bs-primary);
    text-align: right;
    font-weight: bold;
}

@media (max-width: 767.98px) {
    .message-filter-item {
        flex-direction: column;
    }

    .message-item_info {
        width: 100%;
        border-right: none;
    }

    .message-chat {
        width: 100%;
        margin-top: 20px;
    }

    .message-chat_message {
        width: 100%;
    }

    .message-chat_message-inner {
        border-radius: 10px;
        background: var(--bs-gray-100);
    }
}
</style>